export const THIRD_PARTY_DATA_SEGMENT_ACL_OBJECTS = [
    'ThirdPartyDataSegmentDetail',
    'ThirdPartyDataSegmentCreate',
    'ThirdPartyDataSegmentList',
    // 3rd_party_data_providers we don't have route for it, this is fetched as relation with ThirdPartyDataSegmentList
];
